module.exports = __webpack_public_path__ + "dist/img/chase-logo.7cb59481.png";